export const getDomainWithoutSubdomain = (url: string) => {
  const urlParts = new URL(url).hostname.split('.');

  return urlParts.slice(0).slice(-2).join('.');
};
